<template>
   <div>
      <fieldset class="border p-2 marb-12">
         <div class="form-group">
            <div class="row">
               <div class="col">
                  <field-col name="startDate" label="Invite Start Date:" v-model="startDate" :v$="v$.startDate" lcols="1" icols="8" :typ="'date'" labelClassOverride="'label-auto-width'"></field-col>
               </div>
               <div class="col">
                  <field-col name="endDate" label="Invite End Date:" v-model="endDate" :v$="v$.endDate" lcols="1" icols="8" :typ="'date'" labelClassOverride="'label-auto-width'"></field-col>
               </div>
            </div>
         </div>

         <div class="row">
            <div class="form-group col-6">
               <label>Prospect Name:</label>
               <input type="text" class="form-control" maxlength="40" v-model="prospectName"/>
            </div>
         </div>
         <div class="row">
            <div class="form-group col-12">
               <label>Recruiter: <span class="extra-text">(Leave blank for ALL or click <i class="font-small fi-interface-search"></i> button to find a recruiter)</span></label>
               <div class="input-group">
                  <input type="text" class="form-control" disabled="disabled" v-model="recruiterLabel" />
                  <div class="input-group-append">
                     <button class="btn clear-btn" type="button" @click.prevent="handleClear">
                        <i class="fas fa-times"></i>
                     </button>
                     <button class="btn srch-btn" type="button" @click.prevent="handleSearch">
                        <i class="fi-interface-search"></i>
                     </button>
                  </div>
               </div>
            </div>
         </div>
         <div class="row">
            <div class="form-group col-6">
               <label>Level: <span class="extra-text">(of Prospect)</span></label>
               <input type="number" class="form-control" :placeholder="'(1-' + maxLIFE + ')'" v-model="levelNumber"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                  maxlength="2" />
            </div>
         </div>
         <div class="row">
            <div class="form-group col-6">
               <label>Invitation Status:</label>
               <select class="form-control" v-model="appointmentStatusId">
                  <option value="0">ALL STATUSES</option>
                  <option value="-1">All Statuses Except Approved</option>
                  <option value="-2">Invited</option>
                  <option value="8">Approved</option>
                  <option value="7">Awaiting Approval</option>
                  <option value="6">Incomplete</option>
                  <option value="53">Abandoned</option>
               </select>
            </div>
         </div>
      </fieldset>

      <div class="instructions">* All Filters Optional. This report may take up to 20 minutes to run.</div>

      <div class="row mart-24">
         <div class="form-group col-6">
            <button type="button" :disabled="this.v$.$invalid" class="btn btn-lg ml-bk-purple ml-white ml-h-black marr-12" @click.prevent="handleSubmit">
               <template v-if="busy">
                  <i class="fas fa-spinner fa-spin ml-orange"></i>
               </template>
               <template v-if="this.v$.$invalid">
                  <i class="fas fa-exclamation"></i>
                  Correct errors to Submit
               </template>
               <template v-else>
                  <i class="fas fa-check"></i>
                  SUBMIT the Report REQUEST
               </template>
            </button>

            <button type="button" class="btn btn-lg ml-bk-black ml-white ml-h-orange" @click.prevent="handleClear">
               <template v-if="busy">
                  <i class="fas fa-spinner fa-spin ml-orange"></i>
               </template>
               <template v-else>
                  <i class="fas fa-times"></i>
                  CLEAR
               </template>
            </button>
         </div>
      </div>
      <find-recruit 
         :visible="showDialog"
         @onselected="recruiterSelected"
         @oncancelled="clearRecruiter"
      ></find-recruit>
   </div>
</template>

<script>
import moment from 'moment'
import dlgFindRecruit from '@/components/FindRecruiter';
import FieldCol from '../fieldCol.vue';
import { useVuelidate } from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'
import validationService from '../../validators/validatorService';

export default {
   props: ['userId', 'reportId'],
   components: {
      "find-recruit": dlgFindRecruit,
      "field-col" : FieldCol
   },

   // Vuelidate Hooks, Setup and Validations
   setup() {
      return { v$: useVuelidate() }
   },
    validations() {
      return {
         startDate: { 
            isValidDate: helpers.withMessage('Start Date is invalid', validationService.isValidDate)
         },
         endDate: { 
            isValidDate: helpers.withMessage('End Date is invalid', validationService.isValidDate)
         }
      }
   },
   // End Vuelidate Hooks

   data() {
      return {
         startDate: null,
         endDate: null,
         prospectName: '',
         recruiterName: '',
         recruiterLabel: '',
         recruiterAgentNo: '',
         recruiterCompanyNo: '',
         recruiterBlockNo: '',
         recruiterLevel: '',
         appointmentStatusId: null,
         levelNumber: null,
         busy: false,
         showDialog: false,
         maxLIFE: process.env.VUE_APP_MAX_LEVEL_PRODTYPE_LIFE
      }
   },

   methods: {
      handleSearch() {
         this.showDialog = true
      },
      handleClear() {
         this.startDate = null
         this.endDate = null
         this.recruiterName = ''
         this.recruiterLabel = ''
         this.recruiterAgentNo = ''
         this.recruiterCompanyNo = ''
         this.recruiterBlockNo = ''
         this.recruiterLevel = ''
         this.appointmentStatusId = null
         this.levelNumber = null
      },
      clearRecruiter() {
         this.recruiterLabel = ''
         this.recruiterName = ''
         this.recruiterAgentNo = ''
         this.recruiterCompanyNo = ''
         this.recruiterBlockNo = ''
         this.recruiterLevel = ''
         this.showDialog = false
      },
      recruiterSelected(src) {
         this.recruiterName = src.recruiterName   
         this.recruiterAgentNo = src.recruiterAgentNo
         this.recruiterCompanyNo = src.recruiterCompanyNo
         this.recruiterBlockNo = src.recruiterBlockNo
         this.recruiterLevel = src.recruiterLevel
         this.recruiterLabel = `${src.recruiterName} - ${src.recruiterAgentNo}, Level ${src.recruiterLevel}`
         this.showDialog = false
      },
      async handleSubmit() {
         this.$parent.$parent.loadingStart()
         this.busy = true
         let lvl = this.tryParseInt(this.levelNumber, null)
         let sId = this.tryParseInt(this.appointmentStatusId, null)
         let co = this.tryParseInt(this.recruiterCompanyNo, 0)
         let blk = this.tryParseInt(this.recruiterBlockNo, 0)

         let filter = {
            "userId": this.userId,
            "startDate": this.startDate,
            "endDate": this.endDate,
            "recruiterAgentNo": this.recruiterAgentNo == '' ? null : this.recruiterAgentNo,
            "recruiterCompanyNo": co,
            "recruiterBlockNo": blk,
            "prospectName": this.prospectName == '' ? null : this.prospectName,
            "levelNumber": lvl,
            "appointmentStatusId": sId
         }
         let payload = {
            requestDt: new Date(),
            requestedById: this.userId,
            reportId: this.reportId,
            inputJson: JSON.stringify(filter),
            filterText: this.filterText(JSON.stringify(filter))
         }

         await this.$reports.saveRequest(payload)
            .then(item => {
               this.handleClear()
               this.$emit("rpt-submitted");
               this.$parent.$parent.loadingEnd()
               this.busy = false

               this.$swal(
                  "Success!",
                  "Your report request was successfully queued up.",
                  "success"
               )
            })
            .catch(err => {
               this.$parent.$parent.loadingEnd()
               this.busy = false

               this.$swal(
                  "Oops!",
                  "An error occured on loading the page. Please try again later or contact support if the problem persists.",
                  "error"
               )
            })
      },
      filterText(inp) {
         let f = JSON.parse(inp)
         let o = ''
         if (f.startDate != null && f.startDate != '')
            o = o + 'Starting ' + moment(String(f.startDate), moment.ISO_8601).format('MM/DD/YYYY') + ', '
         if (f.endDate != null && f.endDate != '')
            o = o + 'Ending ' + moment(String(f.endDate), moment.ISO_8601).format('MM/DD/YYYY') + ', '
         if (f.recruiterAgentNo != null && f.recruiterAgentNo != '')
            o = o + `Recruiter = "${f.recruiterAgentNo}", `
         if (f.prospectName != null && f.prospectName != '')
            o = o + `Prospect = "${f.prospectName}", `
         if (f.appointmentStatusId != null && f.appointmentStatusId != 0) {
            switch (f.appointmentStatusId) {
               case 6:
                  o = o + 'Incomplete Appointments, '
                  break
               case 7:
                  o = o + 'Awaiting Approval, '
                  break
               case 8:
                  o = o + 'Approved Appointments, '
                  break
               case 53:
                  o = o + 'Abandoned Appointments, '
                  break
               case -1:
                  o = o + 'All Statuses Except Approved, '
                  break
               case -2:
                  o = o + 'Invited Only, '
                  break
               default:
                  o = o + 'ALL Statuses, '
            }
         }
         if (f.levelNumber != null && f.levelNumber != 0) {
            o = o + `Level ${f.levelNumber}, `
         }
         if (o.trim() == '') return '(none)'
         return o.substr(0, o.length - 2)
      },
      tryParseInt(str, defaultValue) {
         var retValue = defaultValue;
         if (str !== null) {
            if (str.length > 0) {
               if (!isNaN(str)) {
                  retValue = parseInt(str);
               }
            }
         }
         return retValue;
      },
   }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/colors.scss';

.srch-btn {
   background-color: $corp-color;
   color: #fff;
   outline: none !important;
   border: 1px solid $corp-color;
   border-top-right-radius: 4px;
   border-bottom-right-radius: 4px;
   font-size: x-small;
   padding: 0px 12px;
}
.srch-btn:focus {
   outline: none !important;
}
.srch-btn:hover {
   background-color: #000;
   color: $corp-orange;
}
.clear-btn {
   background-color: #eee;
   color: $corp-color;
   outline: none !important;
   border: 1px solid $corp-color;
   font-size: smaller;
   padding: 0px 12px;
}
.clear-btn:focus {
   outline: none !important;
}
.clear-btn:hover {
   background-color: $corp-orange;
   color: #fff;
}
.extra-text {
   color: #999;
   font-size: small;
}

</style>